/*
 * @Author: Tina Huang
 * @Date: 2024-01-25 12:57:20
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-03-08 16:42:46
 * @Description:
 */
import { Modal, Form, Input, Button, message } from 'antd'
import { useState } from 'react'
import { saveVIP } from '@/utils'

export default function BindVIP(props: { open: boolean; onClose?: () => void }) {
  const { open, onClose } = props
  const [form] = Form.useForm()
  const [loading, setLodaing] = useState(false)
  const loadingSeconds = 1500
  const [messageApi, contextHolder] = message.useMessage()

  const onBind = () => {
    setLodaing(true)

    const onLoading = (values: any) => {
      setTimeout(() => {
        saveVIP(
          values,
          () => {
            messageApi.success('绑定成功！请继续使用组件或者拷贝模板～')
            onClose?.()
            window.location.reload()
          },
          () => {
            messageApi.error('绑定失败！请确认你的绑定信息，有疑问可联系阿汪小助理！')
          }
        )
        setLodaing(false)
      }, loadingSeconds)
    }

    form
      .validateFields()
      .then((values) => {
        onLoading(values)
      })
      .catch(() => setLodaing(false))
  }

  const handleReturn = () => {
    onClose?.()
  }

  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title="𝕎𝕚𝕕𝕧𝕖𝕣𝕤𝕖 · 会员绑定"
        onCancel={onClose}
        footer={
          <>
            <a href="#/picks">
              <span className="text-blue-600 cursor-pointer mr-4" onClick={handleReturn}>
                您正在会员模版库，返回原模版库
              </span>
            </a>
            <Button type="primary" loading={loading} onClick={onBind}>
              绑定
            </Button>
          </>
        }
      >
        <p>
          由于近期模板二次分享和盗售的情况频发，所以需要绑定<strong>您的会员订单信息</strong>用于获取模板并记录。
        </p>
        <Form form={form} className="mt-8" labelCol={{ span: 5 }}>
          <Form.Item name="order" label="订单号" rules={[{ required: true, message: '请输入订单号' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="phone" label="订单手机号" rules={[{ required: true, message: '请输入订单手机号' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="nickname" label="昵称">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
